import { client } from '../client';
import { INotification } from './types/INotification';

export const acknowledgeNotificationById = async (notification_id: number): Promise<INotification> => {
  const { data } = await client.post(`/notifications/${notification_id}`);

  return data;
};
